// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-title[data-v-978ed996] {\n  font-weight: bold;\n}", ""]);
// Exports
module.exports = exports;
